export default __webpack_public_path__ + "static/media/sajari.c2a3060a.png";